/* eslint-disable jsx-a11y/iframe-has-title */
/**
 * Footer component.
 * @module components/theme/Footer/Footer
 */

import React from 'react';
import { Container, List, Segment } from 'semantic-ui-react';

import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { UniversalLink } from '@plone/volto/components';
import config from '@plone/volto/registry';

const messages = defineMessages({
  copyright: {
    id: 'Copyright',
    defaultMessage: 'Copyright',
  },
});

/**
 * Component to display the footer.
 * @function Footer
 * @param {Object} intl Intl object
 * @returns {string} Markup of the component
 */
const Footer = ({ intl }) => {
  const { settings } = config;
  const lang = useSelector((state) => state.intl.locale);

  return (
    <Segment
      role="contentinfo"
      vertical
      textAlign="center"
      id="footer"
      style={{
        backgroundColor: '#00d8ff',
        color: '#121212',
        marginTop: '-2px',
      }}
    >
      <Container>
        <Segment
          basic
          className="discreet"
          style={{
            backgroundColor: '#00d9ff',
            color: '#121212',
            fontSize: '20px',
          }}
        >
          <span>
            &middot;&middot;&middot; In Memoriam of William, WB9NLI
            &middot;&middot;&middot;
          </span>
          <br />
        </Segment>
        <List horizontal inverted>
          {/* wrap in div for a11y reasons: listitem role cannot be on the <a> element directly */}
          <div
            role="listitem"
            className="item"
            style={{ color: 'black', fontSize: '12px' }}
          >
            <UniversalLink
              className="item"
              href={settings.isMultilingual ? `/${lang}/license` : '/license'}
            >
              <FormattedMessage
                id="License Information"
                defaultMessage="License Information"
                style={{ color: 'black' }}
              />
            </UniversalLink>
          </div>
          <div
            role="listitem"
            className="item"
            style={{ color: 'black', fontSize: '12px' }}
          >
            <UniversalLink
              className="item"
              href={
                settings.isMultilingual
                  ? `/${lang}/privacy_policy`
                  : '/privacy_policy'
              }
            >
              <FormattedMessage
                id="Privay Policy"
                defaultMessage="Privacy Policy"
                style={{ color: 'black' }}
              />
            </UniversalLink>
          </div>
          <div
            role="listitem"
            className="item"
            style={{ color: 'black', fontSize: '12px' }}
          >
            <UniversalLink
              className="item"
              href={settings.isMultilingual ? `/${lang}/terms` : '/terms'}
            >
              <FormattedMessage
                id="Terms of Service"
                defaultMessage="Terms of Service"
                style={{ color: 'black' }}
              />
            </UniversalLink>
          </div>
        </List>
      </Container>
    </Segment>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
Footer.propTypes = {
  /**
   * i18n object
   */
};

export default injectIntl(Footer);
